import axios from "axios";

const BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_ROOT = BASE_URL.endsWith("/api") ? BASE_URL : `${BASE_URL}/api`;
const CHAMADOS_URL = "/cliente/chamados";

const tokenAtual = () => {
  const token = localStorage.getItem("jwtToken")
    || localStorage.getItem("authToken")
    || sessionStorage.getItem("token")
    || "";
  return token.startsWith("Bearer ") ? token.slice(7) : token;
};
const request = async (method, path, { params, data, signal } = {}) => {
  const token = tokenAtual();
  if (!BASE_URL) throw new Error("A URL da API não está configurada.");
  if (!token) throw new Error("Sua sessão não foi encontrada. Entre novamente no portal.");

  try {
    const response = await axios({
      method,
      url: `${API_ROOT}${CHAMADOS_URL}${path}`,
      params,
      data,
      signal,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    if (axios.isCancel(error) || error?.code === "ERR_CANCELED") throw error;
    if (error?.response?.status === 401) window.dispatchEvent(new Event("tokenExpired"));
    const message = error?.response?.data?.erro
      || error?.response?.data?.message
      || error?.response?.data?.detail
      || error?.message
      || "Não foi possível concluir a operação.";
    const requestError = new Error(message);
    requestError.status = error?.response?.status;
    throw requestError;
  }
};

export const suporteApi = {
  listar: (params, signal) => request("get", "", { params, signal }),
  opcoes: (signal) => request("get", "/opcoes", { signal }),
  detalhe: (protocolo, signal) => request("get", "/detalhes", { params: { protocolo }, signal }),
  historico: (protocolo, params, signal) => request("get", "/historico", { params: { protocolo, ...params }, signal }),
  abrir: (dados) => request("post", "", { data: dados }),
  atualizar: (dados) => request("put", "", { data: dados }),
  interagir: (dados) => request("post", "/interacoes", { data: dados }),
  concluir: (dados) => request("post", "/concluir", { data: dados }),
};

export const CLASSIFICACAO_LABELS = {
  AJUSTE_CONTEXTO: "Ajuste de contexto",
  AJUSTE_CONFIGURACAO: "Ajuste de configuração",
  PROBLEMA_INTEGRACAO: "Problema de integração",
  INTEGRACAO_CV: "Integração CV",
  "INTEGRACAO_META-FACEBOOK": "Integração Meta / Facebook",
  INTEGRACAO_WHATSAPP: "Integração WhatsApp",
  SOLICITACAO: "Solicitação",
  DUVIDA: "Dúvida",
  ERRO: "Erro",
  MELHORIA: "Melhoria",
};
